import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVoiceShare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconVoiceShare"><Path d="M9 21H7V3H9V21Z" fill="currentColor"/><Path d="M21 18H19V15.3457C18.1921 16.0959 17.7362 16.7766 17.4629 17.4424C17.0583 18.4278 17 19.4958 17 21H15C15 19.5042 15.0419 18.0722 15.6123 16.6826C15.9993 15.74 16.6072 14.8672 17.5137 14H15V12H21V18Z" fill="currentColor"/><Path d="M13 17H11V7H13V17Z" fill="currentColor"/><Path d="M5 15H3V9H5V15Z" fill="currentColor"/><Path d="M17 10H15V5H17V10Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVoiceShare;
